﻿import React, { useState, useEffect } from 'react';
//import { NavLink } from "react-router-dom";
import GlobalDialog from '../Modal/GlobalDialog';
import { ModalMetadata } from '../../models/modal-metadata';
import { HplcCalculationTypes, ModalMessageType } from '../../models/enums';
import { CalculationDetailsFormula } from '../../models/Documentation/calculation-details-formula';
import { HplcMassSpecCalculator } from '../../models/Calculators/hplc-mass-spec-calculator';
import { HplcMassSpecCalculation } from '../../models/Calculators/hplc-mass-spec-calculation';

//import { HelpDocument } from '../../models/help-document';
//import { CrudFunctions } from '../../utilities/crud-functions'
import { MathJaxContext, MathJax } from 'better-react-mathjax';

import { Button } from 'devextreme-react/button';

export interface Props {
    calculator?: HplcMassSpecCalculator;
    calculation?: HplcMassSpecCalculation;
}

export default function HplcCalculationDetails(props: Props) {
    const [formula1, setFormula1] =
        useState<CalculationDetailsFormula>();

    const [detailsVisible, setDetailsVisible] =
        useState<boolean>(true);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        createFormulas();
    }, [props.calculation, props.calculator]);

    const calculator = props.calculator;
    const calculation = props.calculation;

    console.log(calculator ? calculator.areaValues : "NO AREA VALUES");


    return (

            <div>
            <div className="lq-header pw-margin-bottom-05 pw-bg-neutral-400">
                <div className="lq-header-title">HPLC Calculation Details</div>
                <div className="title-bar-spacer" />
                <div>
                    <Button className="title-bar-button"
                        text="" icon={detailsVisible ? "eyeclose" : "eyeopen"} type="success"
                        hint="show/hide details"
                        onClick={toggleVisibility} />
                </div>
            </div>

            {detailsVisible && calculator && calculation &&
                <MathJaxContext>
                    <MathJax>
                        <div>
                            <div className="pw-margin-bottom-1">
                                <span>Calculation Type: {HplcCalculationTypes[calculation.hplcMassSpecCalculationResultType]}</span>
                            </div>

                            {calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.Identity &&
                                <>
                                    <div>
                                        <span>Difference: {calculator.theoreticalMass} - {calculator.actualMass} = {calculation.identityByHplcMassSpecResult.actualMassDifference} </span>
                                    </div>

                                    <div>
                                        <span>Mass error: ({calculator.actualMass} - {calculator.theoreticalMass}) / {calculator.theoreticalMass} x 1,000,000</span>
                                    </div>
                                </>
                            }

                            {calculator.areaValues && (calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.OverlabeledDistribution ||
                                calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.Distribution) &&
                                <>
                                    <div className="pw-bold">Istotopic Percentages</div>
                                    <div>
                                        {calculator.areaValues.map((item, idx) =>
                                            <div key={`ip-${idx}`}>
                                                <span className="calc-doc-block pw-bold calc-doc-block-label-5">M{idx}: </span>
                                                <span className="calc-doc-block pw-italic calc-doc-block-label-40">M{idx} Area/Area Sum × 100 </span>
                                                <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[idx]}/{calculation.hplcMassSpecOverlabeledDistributionResult.areaSum} × 100 = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].isotopicPercent} </span>
                                            </div>
                                        )}
                                    </div>
                                </>
                            }

                            {calculator.areaValues && calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.OverlabeledDistribution &&
                                <>
                                    <div className="pw-bold pw-margin-top-1">Adjusted Areas</div>
                                    <div>
                                        {calculator.areaValues.map((item, idx) =>
                                            <div key={`aa-${idx}`}>
                                                {idx === 0 &&
                                                    <div>
                                                        <span className="calc-doc-block pw-bold calc-doc-block-label-5">M0: </span>
                                                        <span className="calc-doc-block pw-italic calc-doc-block-label-40">M0 Area </span>
                                                        <span className="calc-doc-block pw-green">{calculation.hplcMassSpecOverlabeledDistributionResult.entries[0].adjustedArea} </span>
                                                    </div>
                                                }
                                                {idx === 1 &&
                                                    <div>
                                                        <span className="calc-doc-block pw-bold calc-doc-block-label-5">M1: </span>
                                                        <span className="calc-doc-block pw-italic calc-doc-block-label-40">M1 Area - (M0 Adjusted Area × M+1%) </span>
                                                        <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[0]}-({calculation.hplcMassSpecOverlabeledDistributionResult.entries[0].adjustedArea} × {calculator.m1Adjustment}%) = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[1].adjustedArea} </span>
                                                    </div>
                                                }
                                                {idx === 2 &&
                                                    <div>
                                                        <span className="calc-doc-block pw-bold calc-doc-block-label-5">M2: </span>
                                                        <span className="calc-doc-block pw-italic calc-doc-block-label-40">M2 Area - (M1 Adusted Area × M+1%) - (M0 Adjusted Area × M+2%) </span>
                                                        <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[1]}-({calculation.hplcMassSpecOverlabeledDistributionResult.entries[0].adjustedArea} × {calculator.m1Adjustment}%) - ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[0].adjustedArea} × {calculator.m2Adjustment}%)  = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[2].adjustedArea} </span>
                                                    </div>
                                                }
                                                {idx > 2 &&
                                                    <div>
                                                        <span className="calc-doc-block pw-bold calc-doc-block-label-5">M{idx}: </span>
                                                        <span className="calc-doc-block pw-italic calc-doc-block-label-40">M{idx} Area - (M{idx + 2} Adusted Area × M+1%) - (M{idx + 1} Adjusted Area × M+2%) </span>

                                                        {!calculator.m3Adjustment && idx < 3 &&
                                                            <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[idx - 1]}-({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                                {calculator.m1Adjustment}%) - ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                                {calculator.m2Adjustment}%)  = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].adjustedArea} </span>
                                                        }

                                                        {calculator.m3Adjustment && idx > 2 &&
                                                            <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[idx - 1]}-({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                                {calculator.m1Adjustment}%) - ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                                {calculator.m2Adjustment}%) -
 
                                                                ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 3].adjustedArea} ×
                                                                {calculator.m3Adjustment})%

                                                                = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].adjustedArea}
                                                            </span>
                                                        }

                                                        {calculator.m3Adjustment && calculator.m4Adjustment && idx > 3 &&
                                                            <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[idx - 1]}-({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                                {calculator.m1Adjustment}%) - ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                                {calculator.m2Adjustment}%) -
 
                                                                ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 3].adjustedArea} ×
                                                                {calculator.m3Adjustment})% -

                                                                ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 4].adjustedArea} ×
                                                                {calculator.m4Adjustment})%

                                                                = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].adjustedArea}
                                                            </span>
                                                        }

                                                        {/*
                                                         (m3Adjustment != null && i > 2 ?
                                                            ((decimal)(distribution.Entries[i - 3].AdjustedArea * m3Adjustment))
                                                        : 0) -
                                                        //apply m+4 if it is defined and the idx > 3
                                                        (m4Adjustment != null && i > 3 ?
                                                            ((decimal)(distribution.Entries[i - 4].AdjustedArea * m4Adjustment))
                                                        : 0)    
                                                            */}


                                                        {/* ORIG:
                                                        <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculator.areaValues[idx - 1]}-({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                            {calculator.m1Adjustment}%) - ({calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx - 2].adjustedArea} ×
                                                            {calculator.m2Adjustment}%)  = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].adjustedArea} </span>
                                                        */}

                                                    </div>
                                                }
                                            </div>
                                        )}
                                    </div>

                                    <div className="pw-bold pw-margin-top-1">Adjusted Isotopic Percentages</div>
                                    <div>
                                        {calculator.areaValues.map((item, idx) =>
                                            <div key={`aip-${idx}`}>
                                                <span className="calc-doc-block pw-bold calc-doc-block-label-5">M{idx}: </span>
                                                <span className="calc-doc-block pw-italic calc-doc-block-label-40">M{idx} Adjusted Area/Adjusted Area Sum × 100 </span>
                                                <span className="calc-doc-block pw-green calc-doc-block-label-40">{calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].adjustedArea}/{calculation.hplcMassSpecOverlabeledDistributionResult.adjustedAreaSum} × 100 = {calculation.hplcMassSpecOverlabeledDistributionResult.entries[idx].adjustedIsotopicPercent} </span>
                                            </div>
                                        )}
                                    </div>
                                </>
                            }

                            {calculator.areaValues && (calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.OverlabeledDistribution ||
                                calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.Distribution) &&
                                <>
                                    <div className="pw-margin-top-1">
                                        <span className="calc-doc-block pw-bold calc-doc-block-label-15">Isotopic Percent: </span>
                                        <span className="calc-doc-block pw-italic calc-doc-block-label-30">M0 Area / M{calculator.targetLabel} Adjusted Area × 100</span>
                                        <span className="calc-doc-block pw-green calc-doc-block-label-20">{calculator.areaValues[0]} / {calculator.areaValues[calculator.targetLabel]} × 100 = {calculation.hplcMassSpecOverlabeledDistributionResult.isotopicPercent}</span>
                                    </div>
                                </>
                            }

                            {calculator.areaValues && calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.OverlabeledDistribution &&
                                <>
                                    <div className="pw-margin-top-1">
                                        <span className="calc-doc-block pw-bold calc-doc-block-label-15">Adjusted Isotopic Percent: </span>
                                        <span className="calc-doc-block pw-italic calc-doc-block-label-30">M0 Adjusted Area / M{calculator.targetLabel} Adjusted Area × 100</span>
                                        <span className="calc-doc-block pw-green calc-doc-block-label-20">{calculation.hplcMassSpecOverlabeledDistributionResult.entries[0].adjustedArea} / {calculation.hplcMassSpecOverlabeledDistributionResult.entries[calculator.targetLabel].adjustedArea} × 100 = {calculation.hplcMassSpecOverlabeledDistributionResult.adjustedIsotopicPercent}</span>
                                    </div>
                                </>
                            }

                            {calculation.hplcMassSpecCalculationResultType === HplcCalculationTypes.Distribution &&
                                <>
                                    <div>
                                        <span>M0: </span>
                                    </div>

                                    <div>
                                        <span>M1: </span>
                                    </div>
                                </>
                            }

                            <br /><br />

                            <div>
                                <span>{`\\(tbw \\times ctp / 100\\over csc/100 \\times (ppc/100 \\times ebd) \\times a/100\\)`}</span>
                            </div>
                            <br /><br />
                            <div>
                                <span>{`\\({\\Large  tbw \\times ctp / 100}\\over {\\Large csc/100 \\times (ppc/100 \\times ebd) \\times a/100} \\)`}</span>
                            </div>

                        </div>
                    </MathJax>
                </MathJaxContext>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function toggleVisibility() {
        setDetailsVisible(!detailsVisible);
    }

    function createFormulas() {
        //createFormula1();


    }


    function createFormula1() {
        if (props.calculator && props.calculation) {

            let f: CalculationDetailsFormula = {
                id: "311a",
                codedLaTeX: "\\(_x_ = {-_b_\\pm\\sqrt{_b_^2 - 4_a__c_}\\over \\cos(2_a_)}\\)",
                variables: [
                    { name: "x", code: "_x_", description: "X value" },
                    { name: "b", code: "_b_", description: "B value &" },
                    { name: "a", code: "_a_", description: "A value:" },
                    { name: "c", code: "_c_", description: "C value---" }
                ]
            }

            if (f && f.codedLaTeX && f.variables) {
                let formattedFormula = f.codedLaTeX;

                for (let v of f.variables) {
                    /*
                    console.log("---");
                    console.log("v");
                    console.log(v);
    
                    console.log("so far:::");
                    console.log(formattedFormula);
                    */

                    if (v.code && v.name)
                        formattedFormula = formattedFormula.replaceAll(v.code, v.name);
                }

                f.laTeX = formattedFormula;

            }

            // laTeX: "\\(x = {-b \\pm \\sqrt{b ^ 2 - 4ac} \\over 2a}.\\)",

            console.log("final:");
            console.log(f);


            setFormula1(f);
        }
    }


    /*
    async function getDocument() {
        if (props.documentId) {
            await CrudFunctions.getData(`documentation/helpdocument/${props.documentId}/${props.parentId}`)
                .then(data => {
                    setInstructions(data.html);
                })
                .catch((res) => {
                    showMessage(res, ModalMessageType.Error, "Error Retrieving Instructions");
                });
        }
    }
    */

    async function getAllData() {
        //await getDocument();
    }

    //navigation

    function goBack() {
        history.back();
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }


    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}